<template>
  <iv-modal :title="title" :width="width" :closable="false" v-model="sources.shown" @on-cancel="onCancel">
    <div style="margin-bottom: 2em;">
      <iv-steps :current="step.current">
        <template v-for="step in step.steps">
          <iv-step :key="step.id" :title="step.name"></iv-step>
        </template>
      </iv-steps>
    </div>
    <template v-if="type=='first'">
      <!-- 批量初审 -->
      <template v-if="step.current == 0">
        <iv-form ref="auditData" :model="sources.firstAuditData" :rules="rules.firstStep1" inline>
          <iv-form-item prop="year">
            <iv-select v-model="sources.firstAuditData.year" style="width:100px">
              <iv-option v-for="item in options.years" :key="item.name" :value="item.id">{{item.name}}</iv-option>
            </iv-select>
          </iv-form-item>
          <iv-form-item prop="industryId">
            <iv-select placeholder="选择行业" v-model="sources.firstAuditData.industryId" style="width:150px">
              <iv-option v-for="item in options.industry" :key="item.name" :value="item.id">{{item.name}}</iv-option>
            </iv-select>
          </iv-form-item>
        </iv-form>
        <iv-alert show-icon>请确保数据已完成录入及核验工作！<br/>批量初审将会跳过异常预警的指标，需人工每条核对！</iv-alert>

        <iv-button type="text" size="large" slot="footer" style="float: left;" @click="onCancel">取消</iv-button>
        <iv-button type="primary" size="large" slot="footer" @click="next(1)">下一步</iv-button>
      </template>
      <template v-if="step.current == 1">
        <iv-alert show-icon>
          <p style="margin-bottom: .625em"><b>确认信息</b></p>
          <p>
            年份：{{ sources.firstAuditData.year }}年<br/>
            所选行业：{{ options.industry | find(sources.firstAuditData.industryId) | field('name') }}
          </p>
        </iv-alert>
        <p>*注：覆盖以上条件数据将会批量通过初审。</p>

        <iv-button type="text" size="large" slot="footer" style="float: left;" @click="step.current=0">上一步</iv-button>
        <iv-button :loading="loader[REPORT_DATA]" type="primary" size="large" slot="footer" @click="onSuccess()">提交</iv-button>
      </template>
    </template>
    <template v-if="type=='audit'">
      <!-- 批量终审 -->
      <template v-if="step.current == 0">
        <iv-form ref="auditData" :model="sources.auditData" :rules="rules.firstStep1" inline>
          <iv-form-item prop="year">
            <iv-select v-model="sources.auditData.year" style="width:100px" @on-change="refreshIndustry">
              <iv-option v-for="item in options.years" :key="item.name" :value="item.id">{{item.name}}</iv-option>
            </iv-select>
          </iv-form-item>
          <iv-form-item prop="industryId">
            <iv-select placeholder="选择行业" v-model="sources.auditData.industryId" style="width:150px">
              <iv-option v-for="item in options.industry" :key="item.name" :value="item.id">{{item.name}}</iv-option>
            </iv-select>
          </iv-form-item>
        </iv-form>
        <iv-alert show-icon>请确保数据已完成录入及核验工作！<br/>批量初审将会跳过异常预警的指标，需人工每条核对！</iv-alert>

        <iv-button type="text" size="large" slot="footer" style="float: left;" @click="onCancel">取消</iv-button>
        <iv-button :loading="loader[AUDIT+'industryAuditCheckAbnormal']" type="primary" size="large" slot="footer" @click="next(1)">下一步</iv-button>
      </template>

      <template v-if="step.current==1">
        <iv-alert show-icon>
          <p style="margin-bottom: .625em"><b>异常值提醒</b></p>
          <p style="white-space:pre;" v-if="sources.abnormal">{{ sources.abnormal.abnormalMsg }}</p>
        </iv-alert>
        <p>备注：建议再次核验异常指标<br>搜索参数，选择行业，选中异常预警-"异常"，选中初审状态-"非初审通过"的数据</p>

        <iv-button type="text" size="large" slot="footer" style="float: left;" @click="step.current=0">上一步</iv-button>
        <iv-button v-if="sources.abnormal && sources.abnormal.hasAbnormal == 1" :loading="loader[AUDIT+'industryAuditCheckAbnormal']" type="primary" size="large" slot="footer" @click="onSuccess('audit', { method:0 })">只通过非异常数据</iv-button>
        <iv-button :loading="loader[AUDIT+'industryAuditCheckAbnormal']" type="primary" size="large" slot="footer" @click="onSuccess('audit', { method:1 })">通过全部</iv-button>
      </template>
    </template>
  </iv-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { RELEASE_TASKS,RELEASE_ADD_POLLING_TASK } from "@/stores/modules/release"
import { BusinessError, RequestError, getProductYear, years } from "@/utils/";
import ModelMixin from "@/mixins/Model.mixin";
import LoaderMixin from "@/mixins/Loader.mixin";
import contact from "@/utils/contact";
import IndustryModel from "@/models/IndustryModel";
import ReportDataModel from "@/models/ReportDataModel";
import AuditModel from "@/models/AuditModel";

const INDUSTRY = IndustryModel.ModelName;
const REPORT_DATA = ReportDataModel.ModelName;
const AUDIT = AuditModel.ModelName;
const FORM_NAME = `${REPORT_DATA}Form`;
const _years = years().map(year=>({...year, title:year.name}))

export default {
  mixins: [
    LoaderMixin(REPORT_DATA, INDUSTRY,AUDIT),
    ModelMixin({
      contact,
      models: [IndustryModel,ReportDataModel,AuditModel],
    }),
  ],
  props: {
    width: {
      type: [String, Number],
      default: "500",
    },
    type: {
      type: String,
      default: "first" //first, audit
    },
    title: String,
    shown: Boolean,
  },
  watch: {
    shown(val) {
      this.sources.shown = val;
    },
  },
  data() {
    return {
      FORM_NAME,
      REPORT_DATA,
      AUDIT,
      step: {
        current: 0,
        steps: [
          { id: 1, name: "选择行业" },
          { id: 2, name: "异常值检测" },
        ],
      },
      options: {
        years: years(),
        industry: []
      },
      sources: {
        //双向绑定字段
        shown: false,
        reportData: null,
        firstAuditData: {
          industryId: "",
          year: getProductYear(),
        },
        auditData: {
          industryId: "",
          year: getProductYear(),
          // method: 0 //TODO：发送数据再传递
        },
        abnormal: null
      },
      rules:{
        firstStep1: {
          industryId: [
              { required: true, type:"number", message: '必须选择行业', trigger: 'blur' }
          ],
        }
      }
    };
  },
  async mounted(){
    this.refreshIndustry(_years[0].id)
  },
  methods: {
    ...mapActions([RELEASE_ADD_POLLING_TASK]),
    async refreshIndustry(year) {
      const industry = await this.$$fetch(INDUSTRY, {year:year});
      if (industry) this.options.industry = industry.data.map(item => ({ ...item, name: item.industry }));
      return this.options.industry;
    },
    onCancel() {
      // this.sources.result = this.value;
      this.hide();
    },
    async onSuccess(type=this.type, params={}) {
      let res;
      switch(type){
        case "first":
          res = await this.$$active(REPORT_DATA, 'industryFirstAudit', this.sources.firstAuditData)
          if(res instanceof Error) return
          this.$$success(res.msg)
          this[RELEASE_ADD_POLLING_TASK]({id: 'industryFirstAudit'+res.data.id, type:'industryFirstAudit', params:res.data})
          this.hide()
          break;
        case "audit":
          res = await this.$$active(AUDIT, 'industryAudit', {...this.sources.auditData,...params})
          if(res instanceof Error) return
          this.$$success(res.msg)
          this[RELEASE_ADD_POLLING_TASK]({id: 'industryAudit'+res.data.id, type:'industryAudit', params:res.data})
          this.hide()
          break;
      }
    },
    async next(step){
      if(step == '1'){
        const validate = await this.$refs.auditData.validate();
        if (!validate) {
          this.$$warning("表单验证不通过，请继续填写。");
          return Promise.reject(new Error("表单验证不通过，请继续填写。"));
        }
      }
      if(this.type=='audit' && step == '1'){
        const res = await this.$$active(AUDIT, 'industryAuditCheckAbnormal', this.sources.auditData)
        if(res instanceof Error) return
        this.sources.abnormal = res.data
      }

      this.step.current = step
    },
    hide() {
      this.step.current = 0
      this.sources.firstAuditData = {
        industryId: "",
        year: getProductYear(),
      };
      this.sources.auditData = {
        industryId: "",
        year: getProductYear(),
      };

      this.sources.shown = false;
      this.$emit("shown-changed", this.sources.shown);
    },
  },
  computed: {
    ...mapGetters([RELEASE_TASKS]),
    repeatDataUnit() {
      return this.sources.reportData && this.sources.reportData.targetUnit ? this.sources.reportData.targetUnit : "--";
    },
  },
};
</script>
<style scoped>
.ivu-tag {
  margin: 5px;
}
.panelList {
  list-style: none;
  padding: 18px 15px;
  font-size: 14px;
  line-height: 28px;
}
.radio-button {
  font-size: 15px;
  border-radius: 5px !important;
}
.addInput {
  margin: 5px;
  display: inline-block;
}
</style>
